import { render } from "./NewWasteCar.vue?vue&type=template&id=bc224616&scoped=true"
import script from "./NewWasteCar.vue?vue&type=script&lang=js"
export * from "./NewWasteCar.vue?vue&type=script&lang=js"

import "./NewWasteCar.vue?vue&type=style&index=0&id=bc224616&scoped=true&lang=css"

import exportComponent from "/home/le01s/projects/amlogger/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc224616"]])

export default __exports__